var _path, _mask;
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SendMessage = function SendMessage(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var fill = !ignoreColor ? color : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: "none",
    viewBox: "0 0 24 24",
    className: className,
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      fill: "#231F20",
      fillRule: "evenodd",
      d: "M15 17.838l-1.856-5.567 5.568-5.57L15 17.839zm2.298-12.55l-5.568 5.568L6.162 9l11.136-3.712zm4.692-2.34a.951.951 0 00-.088-.361.967.967 0 00-.195-.294.96.96 0 00-.384-.23.987.987 0 00-.275-.054c-.022-.001-.042-.006-.065-.006-.1.002-.201.016-.299.048l-18 6a1 1 0 000 1.898l8.525 2.842 2.843 8.526a.998.998 0 001.896 0l6-18a1 1 0 00.048-.3c.001-.023-.005-.045-.006-.07z",
      clipRule: "evenodd"
    })), _mask || (_mask = /*#__PURE__*/_jsx("mask", {
      id: "a",
      width: "20",
      height: "20",
      x: "2",
      y: "2",
      maskUnits: "userSpaceOnUse",
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M15 17.838l-1.856-5.567 5.568-5.57L15 17.839zm2.298-12.55l-5.568 5.568L6.162 9l11.136-3.712zm4.692-2.34a.951.951 0 00-.088-.361.967.967 0 00-.195-.294.96.96 0 00-.384-.23.987.987 0 00-.275-.054c-.022-.001-.042-.006-.065-.006-.1.002-.201.016-.299.048l-18 6a1 1 0 000 1.898l8.525 2.842 2.843 8.526a.998.998 0 001.896 0l6-18a1 1 0 00.048-.3c.001-.023-.005-.045-.006-.07z",
        clipRule: "evenodd"
      })
    })), /*#__PURE__*/_jsx("g", {
      mask: "url(#a)",
      children: /*#__PURE__*/_jsx("path", {
        fill: fill,
        d: "M0 0H24V24H0z"
      })
    })]
  });
};
export default SendMessage;